import A7FIACompositions from "@/pages/a7/A7FIACompositions/main.tsx";
import A7FIAInstruments from "@/pages/a7/A7FIAInstruments/main.tsx";
import A7FIAInstrumentTS from "@/pages/a7/A7FIAInstrumentTS/main.tsx";
import A7FIAIssuers from "@/pages/a7/A7FIAIssuers/main.tsx";
import A7FIAIssuerTS from "@/pages/a7/A7FIAIssuerTS/main.tsx";
import A7FIATimeSerieFiles from "@/pages/a7/A7FIATimeSerieFiles/main.tsx";
import { A7FIAMultiEditCardStandalone } from "@/pages/a7/MultiEdit/a7_fia_multi_edit.tsx";
import { Route, Routes } from "react-router-dom";

import A7FIADownloadCenter from "@/pages/a7/A7FIADownloadCenter/main";

export default function A7Routes() {
  return (
    <Routes>
      <Route path="a7_fia_compositions/*" element={<A7FIACompositions />} />
      <Route path="a7_fia_issuers/*" element={<A7FIAIssuers />} />
      <Route path="a7_fia_issuer_ts/*" element={<A7FIAIssuerTS />} />
      <Route path="a7_fia_instruments/*" element={<A7FIAInstruments />} />
      <Route path="a7_fia_instrument_ts/*" element={<A7FIAInstrumentTS />} />
      <Route
        path="a7_fia_time_serie_files/*"
        element={<A7FIATimeSerieFiles />}
      />
      <Route
        path="a7_fia_multi_edit/instrument/:instrument_id"
        element={<A7FIAMultiEditCardStandalone />}
      />
      <Route
        path="a7_fia_download_center/*"
        element={<A7FIADownloadCenter />}
      />
    </Routes>
  );
}
